import { render, staticRenderFns } from "./DividersandSubheaders.vue?vue&type=template&id=01d66208&"
import script from "./DividersandSubheaders.vue?vue&type=script&lang=js&"
export * from "./DividersandSubheaders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports